import "./App.css";
import AllRoutes from "./Components/All Routes/AllRoutes";

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
